/**
 * Browser entry point: mounts the application into the document.
 *
 * In the `mock` mode the request handlers that stand in for the backend start
 * first, and they are pulled in dynamically so that none of that code reaches
 * the production bundle.
 *
 * @author John Grimes
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import "./index.css";

const container = document.querySelector("#root");
if (!container) {
  throw new Error("The #root container is missing from the document");
}

if (import.meta.env.MODE === "mock") {
  // Dynamic on purpose: a static import would pull the mock backend and its
  // request handlers into the production bundle.
  const { startMockWorker } = await import("./mocks/browser");
  await startMockWorker();
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
